"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F47C00",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0M9.018 13.854a1.127 1.127 0 1 0 0 2.254 1.127 1.127 0 0 0 0-2.254m7.09 2.255a8.27 8.27 0 0 0-8.254-8.255v1.564a6.673 6.673 0 0 1 6.692 6.691zm-8.254-3.891a3.895 3.895 0 0 1 3.891 3.89l1.564-.036a5.446 5.446 0 0 0-5.455-5.454z"
  })]
}), 'RssRing');
//# sourceMappingURL=index.js.map